import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Layout, PageHeader} from '../components';
import CustomerModal from '../components/Modals/CustomerModal';

const AddCustomer = () => {
  const navigate = useNavigate();

  const onBack = () => {
    navigate(-1);
  };

  return (
    <Layout>
      <PageHeader onBack={onBack} />
      <CustomerModal />
    </Layout>
  );
};

export default AddCustomer;
